/*
  ml-header-v2 — behaviour for sections/ml-header-v2 (Search Nav board; Nav Bar concept m).

  States (attributes on [data-ml-header-v2]; the CSS draws them):
    data-scrolled  the page has scrolled past 24px → the floating pill (or white bar)
    data-open      a mega panel is open → the bar turns light even over a dark hero
    data-search    the search field has focus → same
  Whether the page starts over a dark hero is pure CSS, so nothing here runs before the
  header can paint correctly. With this script blocked the header is a complete bar and
  every nav item is a plain link.

  Panels follow the board: open on hover or focus, close 140ms after the pointer leaves
  the header, close at once over the logo, the search field or the actions. A click on a
  closed item opens its panel; a click on the open item follows its link. Escape closes
  and returns focus; ArrowDown on an item moves into its panel.

  Search: two or more characters fetch /search through the Section Rendering API
  (section ml-header-search-results), so each row carries the real member price from
  Liquid. Arrow keys move through the rows. ⌘K / Ctrl+K focuses the field on desktop
  (captured before the legacy search drawer's own shortcut, which keeps phones).
*/
(function () {
  'use strict';
  if (window.__mlHeaderV2) return;
  window.__mlHeaderV2 = true;

  var SCROLL_AT = 24;
  var CLOSE_DELAY = 140;
  var DESKTOP = window.matchMedia('(min-width: 990px)');

  function init(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ml-hv2-item]'));
    var openKey = null;
    var closeTimer = null;
    var suppressFocusOpen = false;

    // ---- scroll ----
    var ticking = false;
    function onScroll() {
      ticking = false;
      var y = window.scrollY || window.pageYOffset || 0;
      root.toggleAttribute('data-scrolled', y > SCROLL_AT);
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(onScroll);
    }, { passive: true });
    onScroll();

    // ---- panels ----
    function panelFor(key) {
      return root.querySelector('[data-ml-hv2-panel="' + key + '"]');
    }
    function itemFor(key) {
      return root.querySelector('[data-ml-hv2-item="' + key + '"]');
    }
    function open(key) {
      window.clearTimeout(closeTimer);
      if (openKey === key) return;
      if (openKey) closeNow();
      var panel = panelFor(key);
      var item = itemFor(key);
      if (!panel || !item) return;
      panel.hidden = false;
      item.setAttribute('aria-expanded', 'true');
      openKey = key;
      root.setAttribute('data-open', key);
      closeResults();
    }
    function closeNow() {
      window.clearTimeout(closeTimer);
      if (!openKey) return;
      var panel = panelFor(openKey);
      var item = itemFor(openKey);
      if (panel) panel.hidden = true;
      if (item) item.setAttribute('aria-expanded', 'false');
      openKey = null;
      root.removeAttribute('data-open');
    }
    function closeSoon() {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () { closeNow(); }, CLOSE_DELAY);
    }

    items.forEach(function (item) {
      var key = item.getAttribute('data-ml-hv2-item');
      item.addEventListener('mouseenter', function () {
        if (DESKTOP.matches) open(key);
      });
      item.addEventListener('focus', function () {
        if (suppressFocusOpen) return;
        if (DESKTOP.matches) open(key);
      });
      item.addEventListener('click', function (e) {
        if (!DESKTOP.matches) return;
        if (openKey !== key) {
          e.preventDefault();
          open(key);
        }
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          open(key);
          var first = panelFor(key) && panelFor(key).querySelector('a[href]');
          if (first) first.focus();
        }
      });
    });

    root.querySelectorAll('[data-ml-hv2-panel]').forEach(function (panel) {
      panel.addEventListener('mouseenter', function () { window.clearTimeout(closeTimer); });
    });
    root.addEventListener('mouseleave', closeSoon);
    root.querySelectorAll('[data-ml-hv2-close]').forEach(function (el) {
      el.addEventListener('mouseenter', function () { closeNow(); });
    });

    // Focus leaving the header closes whatever is open.
    root.addEventListener('focusout', function (e) {
      if (e.relatedTarget && root.contains(e.relatedTarget)) return;
      window.setTimeout(function () {
        if (!root.contains(document.activeElement)) {
          closeNow();
          closeResults();
          root.removeAttribute('data-search');
        }
      }, 0);
    });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) {
        closeNow();
        closeResults();
      }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (openKey) {
        var item = itemFor(openKey);
        closeNow();
        // Return focus without the focus handler reopening the panel.
        suppressFocusOpen = true;
        if (item) item.focus({ preventScroll: true });
        suppressFocusOpen = false;
      }
      if (input && !results.hidden) {
        closeResults();
        input.focus();
      }
    });

    // ---- search ----
    var form = root.querySelector('[data-ml-hv2-search]');
    var input = root.querySelector('[data-ml-hv2-input]');
    var results = root.querySelector('[data-ml-hv2-results]');
    var list = root.querySelector('[data-ml-hv2-results-list]');
    var qEcho = root.querySelector('[data-ml-hv2-q]');
    var searchTimer = null;
    var lastQ = '';
    var reqId = 0;

    function closeResults() {
      if (!results) return;
      results.hidden = true;
      if (input) {
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
      }
    }
    function showResults() {
      if (!results) return;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }
    function options() {
      return list ? Array.prototype.slice.call(list.querySelectorAll('[role="option"]')) : [];
    }
    function fetchResults(q) {
      var id = ++reqId;
      var url = '/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&section_id=ml-header-search-results';
      fetch(url, { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.text() : ''; })
        .then(function (html) {
          if (id !== reqId || !html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var body = doc.querySelector('[data-ml-hsr]');
          list.innerHTML = body ? body.innerHTML : '';
          if (qEcho) qEcho.textContent = q;
          if (document.activeElement === input && input.value.trim().length >= 2) showResults();
        })
        .catch(function () {});
    }

    if (form && input && results) {
      input.addEventListener('focus', function () {
        root.setAttribute('data-search', '');
        closeNow();
        if (input.value.trim().length >= 2 && list.children.length) showResults();
      });
      input.addEventListener('blur', function () {
        window.setTimeout(function () {
          if (!form.contains(document.activeElement)) {
            root.removeAttribute('data-search');
            closeResults();
          }
        }, 120);
      });
      input.addEventListener('input', function () {
        var q = input.value.trim();
        window.clearTimeout(searchTimer);
        if (q.length < 2) {
          closeResults();
          lastQ = q;
          return;
        }
        searchTimer = window.setTimeout(function () {
          if (q === lastQ && list.children.length) { showResults(); return; }
          lastQ = q;
          fetchResults(q);
        }, 160);
      });
      input.addEventListener('keydown', function (e) {
        var opts = options();
        if (!opts.length || results.hidden) return;
        var cur = opts.findIndex(function (o) { return o.getAttribute('aria-selected') === 'true'; });
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          var next = e.key === 'ArrowDown' ? (cur + 1) % opts.length : (cur <= 0 ? opts.length - 1 : cur - 1);
          opts.forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
          opts[next].setAttribute('aria-selected', 'true');
          input.setAttribute('aria-activedescendant', opts[next].id);
          opts[next].scrollIntoView({ block: 'nearest' });
        } else if (e.key === 'Enter' && cur >= 0) {
          e.preventDefault();
          window.location.assign(opts[cur].getAttribute('href'));
        }
      });
      form.addEventListener('submit', function (e) {
        if (!input.value.trim()) e.preventDefault();
      });

      // ⌘K / Ctrl+K on desktop focuses this field, ahead of the legacy drawer's shortcut.
      window.addEventListener('keydown', function (e) {
        if (!DESKTOP.matches) return;
        var mod = e.metaKey || e.ctrlKey;
        if (!mod || String(e.key).toLowerCase() !== 'k') return;
        if (!input.offsetParent) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        input.focus();
        input.select();
      }, true);
    }

    // ---- phone: hand the menu to the legacy drawer ----
    var menuBtn = root.querySelector('[data-ml-hv2-menu]');
    if (menuBtn) {
      menuBtn.addEventListener('click', function () {
        var legacy = document.querySelector('[data-header-menu-open]');
        if (legacy) legacy.click();
        else window.location.assign('/collections/all');
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-ml-header-v2]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
